
export default function fieldCond(fieldName, values){
    if (values.length > 0) {
        let expression = '';
        values.forEach((value) => {
            if (expression !== '') {
                expression += '||';
            }
            let trimedValue = value.trim();
            if (trimedValue.length > 0)
                expression += '"' + encodeURI(trimedValue) + '"';
        });
        return expression.length > 0 ? fieldName +':(' + expression + ') ' : '';
    }
    return '';
}
